import { Component, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { ReportScheduleFormComponent } from '@shared/components/report-schedule-form/report-schedule-form.component';
import { ReportLayoutDefinition } from 'app/modules/reporting/reporting.types';
import { ReportLayout } from 'app/modules/reports/reports.types';

@Component({
  selector: 'app-reporting-builder-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  standalone: true,
  imports: [MatLegacyFormFieldModule, MatLegacyCheckboxModule, ReactiveFormsModule, ReportScheduleFormComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportingBuilderConfigurationComponent {
  @Input() layout: ReportLayout<ReportLayoutDefinition>;
  @Output() configurationChanged = new EventEmitter<any>();

  scheduleChanged(value: Partial<ReportLayout<any>>): void {
    this.configurationChanged.emit({ ...this.layout, ...value });
  }
}
